"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormDispatchContext = react_1.default.createContext(function () { });
var FormStateContext = react_1.default.createContext({
    values: {},
    errors: {},
    processing: false,
});
function formReducer(state, action) {
    var _a;
    switch (action.type) {
        case 'update': {
            return __assign(__assign({}, state), { values: __assign(__assign({}, state.values), (_a = {}, _a[action.key] = action.data, _a)) });
        }
        case 'update.errors': {
            return __assign(__assign({}, state), { errors: __assign({}, action.data) });
        }
        case 'processing.start': {
            return __assign(__assign({}, state), { processing: true });
        }
        case 'processing.stop': {
            return __assign(__assign({}, state), { processing: false });
        }
        default: {
            throw new Error('Unhandled action type');
        }
    }
}
function FormProviders(props) {
    var children = props.children, onChange = props.onChange, data = props.data, errors = props.errors, processing = props.processing;
    var _a = react_1.default.useReducer(formReducer, { values: data, errors: errors }), state = _a[0], dispatch = _a[1];
    react_1.default.useEffect(function () { return onChange(state.values); }, [state]);
    react_1.default.useEffect(function () { return dispatch({ type: 'update.errors', data: errors }); }, [errors]);
    react_1.default.useEffect(function () { return dispatch({ type: processing ? 'processing.start' : 'processing.stop' }); }, [
        processing,
    ]);
    return (react_1.default.createElement("div", { className: "p-10" },
        react_1.default.createElement(FormStateContext.Provider, { value: state },
            react_1.default.createElement(FormDispatchContext.Provider, { value: dispatch }, children))));
}
exports.FormProviders = FormProviders;
function useFormState() {
    var context = react_1.default.useContext(FormStateContext);
    if (context === undefined) {
        throw new Error('useFormState must be used within a FormProvider');
    }
    return context.values;
}
exports.useFormState = useFormState;
function useFormErrors() {
    var context = react_1.default.useContext(FormStateContext);
    if (context === undefined) {
        throw new Error('useFormErrors must be used within a FormProvider');
    }
    return context.errors;
}
exports.useFormErrors = useFormErrors;
function useFormIsProcessing() {
    var context = react_1.default.useContext(FormStateContext);
    if (context === undefined) {
        throw new Error('useIsProcessing must be used within a FormProvider');
    }
    return context.processing;
}
exports.useFormIsProcessing = useFormIsProcessing;
function useFormDispatch() {
    var context = react_1.default.useContext(FormDispatchContext);
    if (context === undefined) {
        throw new Error('useFormDispatch must be used within a FormProvider');
    }
    return context;
}
exports.useFormDispatch = useFormDispatch;
//# sourceMappingURL=FormContext.js.map